<template>
  <product-section
    title="Akcesoria"
    padding-only-title
    disable-mobile-background
    disable-margin-bottom
    :h-tag="false"
    v-if="data && data.length"
  >
    <LazyHydrate when-visible>
      <slider-tiles
        :items="data"
        :slides-per-view="1"
        :breakpoints="{
          600: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }"
        :loading="loading"
        nav-buttons-type="rounded"
      />
    </LazyHydrate>
  </product-section>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration';
import SliderTiles from '~/components/Sliders/SliderTiles';
import ProductSection from '~/components/Product/ProductSection';

export default {
  name: 'ProductAccessories',
  components: { ProductSection, LazyHydrate, SliderTiles },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      data: null,
    };
  },
  async fetch() {
    if (this.products.length) {
      this.data = this.products;
      this.loading = false;
    } else {
      try {
        const { data } = await this.$axios.get(
          `${this.$config.baseOfixApi}/e-commerce/v1/products/${this.$route.params.slug}`,
          {
            params: {
              includeBreadcrumbs: false,
              includeProduct: false,
              includeSeoData: false,
              includeAccessories: true,
              includeSimilarProducts: false,
              includeOtherProducts: false,
              includeOtherProductsWithSameBrand: false,
            },
            useCache: true,
          },
        );
        this.data = data.accessories;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    }
  },
  watch: {
    data(val) {
      if (val && val.length) {
        this.$emit('productSectionData', true);
      }
    },
  },
};
</script>
